// extracted by mini-css-extract-plugin
export default {"tooltip":"useChartConfig_tooltip__UXT0a"};